import React from 'react';
import PropTypes from 'prop-types';
import { Alert as AlertBootstrap} from 'react-bootstrap';
import classes from './alert.scss';
import appconfig from 'config/appconfig';

export const Alert = (props) => (
  <div>
    <AlertBootstrap bsStyle={props.type} onDismiss={props.handleDismiss}>
      <div className={classes.alertContainer}>
        <div className={classes.content}>
          {props.icon}
          {props.body}
          {props.buttons}
        </div>
      </div>
    </AlertBootstrap>
  </div>
);

Alert.defaultProps = {
  type: appconfig.alertTypes.WARNING,
  handleDismiss: () => {},
};

Alert.propTypes = {
  type: PropTypes.oneOf([
    'warning',
    'danger',
    'success',
    'info',
  ]),
  icon: PropTypes.any,
  body: PropTypes.any.isRequired,
  buttons: PropTypes.any,
  handleDismiss: PropTypes.func,
};

export default Alert;
